import { useEffect, useState } from 'react';
import { Result } from 'antd';
import { useTranslation } from 'react-i18next';
import AppLoader from '../../common/components/AppLoader';
import { routesPath } from '../../common/constants/routesPath';
import { IMPERSONATION_ERROR_CODES, IMPERSONATION_NAMESPACE } from '../../common/constants/impersonation';
import { redeemHandoff } from '../../services/impersonationService';

const isRefusedCode = error =>
    error?.response?.status === 400 || error?.response?.data?.code === IMPERSONATION_ERROR_CODES.HANDOFF_INVALID;

/**
 * Landing page of the "open as user" link from the dealer app (/impersonate#code=...). The pre-init
 * (impersonationPreInit.js, the first import of index.js) has already flagged the tab and taken the code out of the
 * URL; this page redeems it, then reloads into the app. Rendered outside Providers/AuthGuard: there is no session
 * yet, and a failure must not lead to the sign-in form.
 */
const Impersonate = () => {
    const { t } = useTranslation([IMPERSONATION_NAMESPACE]);
    const [failure, setFailure] = useState(null);

    useEffect(() => {
        let isMounted = true;

        redeemHandoff()
            // a full reload, so every module starts from the stored session
            .then(() => window.location.replace(routesPath.ROOT.DASHBOARD))
            .catch(error => {
                if (isMounted) {
                    setFailure(isRefusedCode(error) ? 'invalid' : 'failed');
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    if (!failure) {
        return <AppLoader />;
    }

    return (
        <Result status="warning" title={t(`handoff.${failure}.title`)} subTitle={t(`handoff.${failure}.description`)} />
    );
};

export default Impersonate;
